export const SUBTREND_BG_COLOR = "D7EAFE"
